import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IProductTitleStyles } from "./ProductTitle.types"

export const ProductTitleStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IProductTitleStyles>
> = (theme: IPartialTheme) => ({
    root: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
        minWidth: 0
    },

    modal: {
        selectors: {
            ".ms-Overlay": {
                backgroundColor: `${theme.palette?.white}40`
            },
            ".ms-Dialog-main": {
                display: "flex"
            },
            ".ms-Modal-scrollableContent": {
                display: "flex",
                flex: 1,
                flexDirection: "column"
            }
        }
    },

    modalHeader: {
        position: "absolute",
        right: 0,
        zIndex: 1,
        selectors: {
            ".ms-Button:hover": {
                backgroundColor: "transparent"
            },
            ".ms-Button:active": {
                backgroundColor: "transparent"
            },
            ".ms-Button:hover:active": {
                backgroundColor: "transparent"
            }
        }
    },

    modalImage: {
        flex: 1,
        display: "flex",
        justifyContent: "center",
        selectors: {
            img: {
                height: "100%"
            }
        }
    },

    text: {
        minWidth: 0
    },

    title: {
        display: "block",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        width: "100%",
        fontSize: 18
    },

    id: {},
    headerImage: {}
})
